/**
 * Privacy Policy & Cookies content labels
 */
import svPrivacy from '../locales/sv/privacy.json';
import enPrivacy from '../locales/en/privacy.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

const getPrivacyLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enPrivacy : svPrivacy;
};

export const privacyLabels = (lang?: Language) => getPrivacyLocale(lang);
